angular.module('picmonicng').component('homeSearch', {
  templateUrl: '/templates/app/directives/home-search/home-search.html',
  bindings: {},
  controller: [
    '$filter',
    'UserService',
    'Picmonics',
    'User',
    'MarketOptionsConfig',
    'BrowseService',
    function ($filter, UserService, Picmonics, User, MarketOptionsConfig, BrowseService) {
      const searchResultsElement = document.getElementById('search-results');
      var ctrl = this;

      ctrl.menuItemClicked = false;
      ctrl.searching = false;
      ctrl.searchOpen = false;
      ctrl.market = MarketOptionsConfig.getMarketById(UserService.user.lead);

      ctrl.search = function () {
        ctrl.searching = true;

        ctrl.results = Picmonics.search({
          source: 'find-picmonic',
          query: ctrl.searchTerm,
          page: 1,
          searchPicmonics: true,
          searchPathways: true,
          searchPlaylists: true,
          searchBreadcrumbs: true,
          sort_by: 'relevance',
          include_ugc: false,
          quick: 0,
        });

        ctrl.results.$promise.finally(function () {
          ctrl.searching = false;
          ctrl.searchOpen = true;
        });

        searchResultsElement.scrollTop = 0;
      };

      ctrl.goToPathway = function (pathway) {
        BrowseService.go(
          'app.pathways.market.' + pathway.pathway_type + '.tracks' + (pathway.track_id ? '.picmonics' : ''),
          {
            curriculum: pathway.curriculum,
            market: MarketOptionsConfig.getMarketById(pathway.market_id).slug,
            pathway_id: pathway.pathway_id,
            track_id: pathway.track_id,
            scroll_to: pathway.tertiary_pathway_id ? pathway.tertiary_pathway_id : pathway.secondary_pathway_id,
          }
        );
      };

      ctrl.goToPlaylist = function (playlist) {
        BrowseService.go('app.playlists.playlist', {
          playlist_id: playlist.playlist_id,
        });
      };

      ctrl.generateBreadCrumbs = function (item) {
        var buffer = '';
        var arrow_right = ' &rsaquo; ';
        var title = item.name;

        if (item.root_pathway_type) {
          var found = false;
          angular.forEach(ctrl.market.sections, function (section) {
            if (
              section.pathway_type == item.root_pathway_type &&
              section.curriculum == item.root_curriculum &&
              !found
            ) {
              buffer += $filter('ucfirst')(section.name);
              found = true;
            }
          });
        }

        if (item.root_name && item.root_name != title) {
          if (buffer.length) {
            buffer += arrow_right;
          }
          buffer += item.root_name;
        }

        if (item.sub_pathway_name && item.sub_pathway_name != title) {
          if (buffer.length) {
            buffer += arrow_right;
          }
          buffer += item.sub_pathway_name;
        }

        if (item.further_sub_pathway_name && item.further_sub_pathway_name != title) {
          if (buffer.length) {
            buffer += arrow_right;
          }
          buffer += item.further_sub_pathway_name;
        }

        return buffer;
      };

      ctrl.getExamName = function (exam) {
        var sections = $filter('filter')(ctrl.market.sections, {
          curriculum: exam.exam,
        });
        if (sections.length) {
          return sections[0].name;
        } else {
          return exam.exam.replace('-', ' ').ucwords();
        }
      };

      ctrl.goToExam = function (exam) {
        BrowseService.go('home', {
          visible_content: 'boards_' + exam.curriculum,
        });
      };

      ctrl.width = window.innerWidth > 0 ? window.innerWidth : screen.width;

      ctrl.handleMenuItemClick = () => {
        ctrl.menuItemClicked = true;
      };

      ctrl.handleOnBlurSearchInput = () => {
        if (!ctrl.menuItemClicked) {
          ctrl.searchOpen = false;
        }
        ctrl.menuItemClicked = false;
      };

      ctrl.getNumberOfMinutes = seconds => {
        if (seconds < 60) {
          return 1;
        }

        return Math.round(seconds / 60);
      };
    },
  ],
});
